module.exports = __webpack_public_path__ + "static/media/ImgPDF2.d9e89807.svg";